const submitReviewOfferForm = (values = {}, dispatch, props) => {
  const {
    acceptOffer,
    acceptOfferCb
  } = props;

  acceptOffer(values, (response, billing) => {
    acceptOfferCb(response, billing);
  });
};

export default submitReviewOfferForm;
